export type RumDomain = 'claim_intake' | 'advisor_chat' | 'agent_chat';

export type RunWithRumTrackingParams<T> = Readonly<{
  domain: RumDomain;
  operation: string;
  event?: string;
  startAttributes?: Record<string, unknown>;
  run: () => Promise<T>;
  completeAttributes?: (result: T) => Record<string, unknown>;
  errorAttributes?: (error: unknown) => Record<string, unknown>;
  skippedAttributes?: (result: T) => Record<string, unknown> | null;
}>;

type RumTracker = <T>(params: RunWithRumTrackingParams<T>) => Promise<T>;

let rumTracker: RumTracker | null = null;

/** Host app registers doc-ui `runWithRumTracking` after datadogRum.init (see applyRumSettings / RumSettingsSync). */
export function registerRumOperationTracker(tracker: RumTracker | null): void {
  rumTracker = tracker;
}

export async function runWithOptionalRumTracking<T>(
  params: RunWithRumTrackingParams<T>,
): Promise<T> {
  if (!rumTracker) {
    return params.run();
  }
  return rumTracker(params);
}

/** Advisor chat lives in doc-data; host registers the tracker from doc-ui. */
export async function trackAdvisorChatOperation<T>(
  params: Omit<RunWithRumTrackingParams<T>, 'domain'>,
): Promise<T> {
  return runWithOptionalRumTracking({ domain: 'advisor_chat', ...params });
}
